import React from 'react'
import Header from '../../../../Components/Header'
import Pick from './Pick'
import { useLocation } from 'react-router-dom';


const Createpick = () => {
  const location = useLocation();
  console.log("check pick list id is here ",location);

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Pick pickListId={location.state} />
      </div>
    </div>
  )
}

export default Createpick